(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('allergen', {
                parent: 'entity',
                url: '/allergen',
                data: {
                    authorities: [],
                    pageTitle: 'Allergens'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/allergen/list/allergen.html',
                        controller: 'AllergenController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_ALLERGEN];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_ALLERGEN, access);
                }]
            });
    }
})();
